// extracted by mini-css-extract-plugin
module.exports = {"sigr403":"sigr403"};